import script from "./ViewCommandes.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewCommandes.vue?vue&type=script&setup=true&lang=ts"

import "./ViewCommandes.vue?vue&type=style&index=0&id=b714b784&lang=scss"

const __exports__ = script;

export default __exports__